module.exports = __webpack_public_path__ + "assets/img/gjiedian@2x.affece72.png";